import React from 'react'
import PropTypes from 'prop-types'
import './style.css'

import CircleRemove from "../../_common/_icons/CircleRemove"

const BannerThumbnail = ({
                             banner,
                             onClick,
                             active,
                             onRemoveButtonClick
                         }) => {

    return (
        <div
            onClick={onClick}
            className={`nrt-slide-thumbnail ${active ? 'clicked' : ''}`}
            style={{backgroundImage: `url('${banner.imgSrc}')`}}>

            <a className={'remove-button'}
               onClick={(evt) => {
                   evt.stopPropagation()
                   onRemoveButtonClick()
               }}>
                <CircleRemove style={{height: 32}}/>
            </a>
        </div>
    )
}

BannerThumbnail.propTypes = {
    banner: PropTypes.object.isRequired,
    active: PropTypes.bool,
    onRemoveButtonClick: PropTypes.func.isRequired,
    onClick: PropTypes.func.isRequired,
}

BannerThumbnail.defaultProps = {
    active: false,
}

export default BannerThumbnail



// WEBPACK FOOTER //
// ./src/components/_admin/BannerThumbnail/index.js